import { validate as veeValidate } from 'vee-validate'
import type { ValidationResult } from 'vee-validate/dist/types/types'

export class Validator<T> {
  private validationObject: ValidationResult = {
    valid: false,
    errors: [],
    failedRules: {},
  }

  constructor(private field: T, private fieldName: string) {}

  async validate(validationRules: string) {
    this.validationObject = await veeValidate(this.field, validationRules, {
      name: this.fieldName,
    })
    if (!this.validationObject.valid) throw new Error('Validation failed')
  }

  get errors(): string[] {
    return this.validationObject.errors
  }
}
